import CommonFilterStore from '../CommonFilter/Store';

class SchoolPartnerFilterStore extends CommonFilterStore {
  getFilterValues(): string[] {
    return this._filters.schoolPartners.map((sp) => sp.payload.name.text);
  }
}

export default SchoolPartnerFilterStore;
